import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Content } from "../../../../../../../../../../../dependencies/getContent/Content";
import { getUserType } from "../../utils";
import { fetchIsBeelineUser } from "./api/checkCtn";
export var getIsBeelineError = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(accountNumber) {
    var _Content$getInstance$, phoneInputErrorTexts, widgetPayUrl, phoneInput, isBeelineUser;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _Content$getInstance$ = Content.getInstance().getData(), phoneInputErrorTexts = _Content$getInstance$.phoneInputErrorTexts, widgetPayUrl = _Content$getInstance$.widgetPayUrl, phoneInput = _Content$getInstance$.phoneInput;
          if (!phoneInput.shouldSkipValidation) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", undefined);
        case 3:
          _context.next = 5;
          return fetchIsBeelineUser({
            accountNumber: accountNumber,
            userType: getUserType(accountNumber),
            baseUrl: widgetPayUrl
          });
        case 5:
          isBeelineUser = _context.sent;
          if (!isBeelineUser) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", undefined);
        case 8:
          return _context.abrupt("return", phoneInputErrorTexts === null || phoneInputErrorTexts === void 0 ? void 0 : phoneInputErrorTexts.beeline);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getIsBeelineError(_x) {
    return _ref.apply(this, arguments);
  };
}();